class recommendedProducts extends HTMLElement {
    constructor() {
        super();

        // Bind event handlers so we can remove them later
        this._onUpsellLoaded = () => {
            this.setupATC()
            this.setupSelect()
        };
        this._onRefresh = () => this.refreshRecommendations();
    }

    connectedCallback() {
        // Prevent duplicate event binding if reconnected
        if (this._mountedOnce) return;
        this._mountedOnce = true;

        document.addEventListener('upsell:loaded', this._onUpsellLoaded);
        document.addEventListener('upsell:added', this._onRefresh);
        document.addEventListener('product:added', this._onRefresh);
        document.addEventListener('product:deleted', this._onRefresh);

        this.refreshRecommendations();
    }

    disconnectedCallback() {
        // Remove all listeners when element is detached
        document.removeEventListener('upsell:loaded', this._onUpsellLoaded);
        document.removeEventListener('upsell:added', this._onRefresh);
        document.removeEventListener('product:added', this._onRefresh);
        document.removeEventListener('product:deleted', this._onRefresh);
    }

    async refreshRecommendations() {

        if (this.refreshing) return;
        this.refreshing = true;

        try {
            await this.setHighestPricedProductId();
            await this.loadRecommendations();
        } finally {
            this.refreshing = false;
        }
    }

    async setHighestPricedProductId() {
        try {
            const res = await fetch(`${this.dataset.cartUrl}.js`);
            const cart = await res.json();

            if (cart.items.length > 0) {
                const highestPricedItem = cart.items.reduce((max, item) => {
                    return (item.final_price > max.final_price) ? item : max;
                }, cart.items[0]);

                this.dataset.productId = highestPricedItem.product_id;
            }
        } catch (err) {
            console.error('Error fetching cart:', err);
        }
    }

    async loadRecommendations() {
        const response = await fetch(`${this.dataset.url}?product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}`);
        const responseHTML = await response.text();
        const html = document.createElement("div");

        html.innerHTML = responseHTML;

        const recommendations = html.querySelector("recommended-products");
        if (recommendations?.innerHTML.trim().length > 0) {
            document.querySelector('#side-cart-upsells').innerHTML = recommendations.innerHTML;
        }
        const event = new CustomEvent('upsell:loaded');
        document.dispatchEvent(event);
    }

    async addToCart(button) {
        if (!button) return;

        const form = button.closest('.upsell').querySelector('form');
        if (form) {
            const formData = new FormData(form);

            try {
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: formData
                });
                return await response.json();
            } catch (error) {
                console.error('Error:', error);
            }
        }
    }

    setupATC() {
        const buttons = document.querySelectorAll("#side-cart-upsells button");

        buttons.forEach(button => {
            // Remove any existing listener by replacing the element with a clone
            const newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);

            // Add fresh listener
            newButton.addEventListener('click', async (e) => {
                await this.addToCart(e.target);
                const event = new CustomEvent('upsell:added', {
                    detail: { target: e.target }
                });
                document.dispatchEvent(event);
            });
        });
    }

    setupSelect() {
        document.querySelectorAll('[data-variant-wrapper]').forEach(wrapper => {
            const selected = wrapper.querySelector('[data-variant-selected]');
            const options = wrapper.querySelector('[data-variant-options]');
            const hiddenSelect = wrapper.querySelector('[data-variant-hidden]');
            const productImage = wrapper.closest('.upsell').querySelector('.product-image img');

            let placeholder = null; // comment placeholder when portaled

            const openDropdown = () => {
                // Save position
                const rect = selected.getBoundingClientRect();

                // Create placeholder in DOM so we can restore later
                placeholder = document.createComment('dropdown-portal');
                options.parentNode.insertBefore(placeholder, options);

                // Move dropdown to body
                options.style.display = 'block';
                options.style.position = 'fixed';
                options.style.zIndex = 99999;
                options.style.top = rect.bottom + 'px';
                options.style.left = rect.left + 'px';
                options.style.minWidth = rect.width + 'px';
                options.style.maxWidth = 'fit-content';
                document.body.appendChild(options);

                // Reposition on resize/scroll
                const reposition = () => {
                    const r = selected.getBoundingClientRect();
                    options.style.top = r.bottom + 'px';
                    options.style.left = r.left + 'px';
                    options.style.minWidth = r.width + 'px';
                };
                window.addEventListener('scroll', reposition, true);
                window.addEventListener('resize', reposition);

                // Close on outside click
                const closeHandler = (e) => {
                    if (!options.contains(e.target) && !selected.contains(e.target)) {
                        closeDropdown();
                    }
                };
                document.addEventListener('mousedown', closeHandler);

                // Store cleanup on element for reuse
                options._cleanup = () => {
                    window.removeEventListener('scroll', reposition, true);
                    window.removeEventListener('resize', reposition);
                    document.removeEventListener('mousedown', closeHandler);
                };
            };

            const closeDropdown = () => {
                if (!placeholder) return;
                // Restore back inside wrapper
                placeholder.parentNode.insertBefore(options, placeholder);
                placeholder.remove();
                placeholder = null;

                options.style.display = 'none';
                options.style.position = '';
                options.style.zIndex = '';
                options.style.top = '';
                options.style.left = '';
                options.style.minWidth = '';

                if (options._cleanup) {
                    options._cleanup();
                    delete options._cleanup;
                }
            };

            selected.addEventListener('click', () => {
                const isOpen = options.style.display === 'block' && document.body.contains(options);
                if (isOpen) {
                    closeDropdown();
                } else {
                    openDropdown();
                }
            });

            options.querySelectorAll('.variant-option').forEach(option => {
                option.addEventListener('click', () => {
                    const value = option.getAttribute('data-value');
                    hiddenSelect.value = value;

                    // Update selected display
                    selected.innerHTML = option.innerHTML + `
          <span class="chevron-arrow" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
              class="bi bi-chevron-down" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293
              l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708
              0l-6-6a.5.5 0 0 1 0-.708"/>
            </svg>
          </span>`;

                    // Trigger change
                    hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));

                    // Update product image
                    const variantImg = option.dataset.image;
                    if (variantImg && productImage) {
                        productImage.src = variantImg;
                    }

                    // Close dropdown
                    closeDropdown();
                });
            });
        });
    }


}

export { recommendedProducts };
